import { TableRow, TableCell, Table, TableHead, TableBody, Collapse } from "@mui/material";
import { FC } from "react";
import { IProforma } from "../../../../interfaces/IProforma";
import PositionItem from "./PositionItem";

interface PositionsTableProps {
    invoiceId: string;
    positions: IProforma['positions']
    expand: boolean;
}

const PositionsTable: FC<PositionsTableProps> = ({
    invoiceId,
    positions,
    expand
}) => {
    return (
        <TableRow key={invoiceId}>
            <TableCell colSpan={10} sx={{ p: 0 }}>
                <Collapse in={expand} timeout="auto" unmountOnExit>
                    <Table size="small" sx={{ width: "100%", background: "#eff0f1ff" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 600, width: "16%" }}>Nazwa</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "20%" }}>Opis</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "10%" }}>Ilość</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "16%" }}>Cena brutto</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "10%" }}>VAT (%)</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "16%" }}>Wartość brutto</TableCell>
                                <TableCell sx={{ fontWeight: 600, width: "12%", pl: 7 }}>ZD</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {positions.map((pos) => (
                                <PositionItem invoiceId={invoiceId} pos={pos} key={pos._id} />
                            ))}
                        </TableBody>
                    </Table>
                </Collapse>
            </TableCell>
        </TableRow>
    )
}

export default PositionsTable;